import { render, staticRenderFns } from "./UserManagementDropdown.vue?vue&type=template&id=2052cf2c&scoped=true"
import script from "./UserManagementDropdown.vue?vue&type=script&lang=js"
export * from "./UserManagementDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2052cf2c",
  null
  
)

export default component.exports